import { createReducer, on } from '@ngrx/store';
import * as VirtualScrollActions from './virtual-scroll.actions';

export const virtualScrollFeatureKey = 'inViewport';

export interface State {
  inViewport: Record<any, boolean>;
  hasRendered: Record<any, boolean>;
  userHasScrolled: boolean;

  /**
   * If virtualization is enabled.
   *
   * @description It can be disabled if the feature flag is off,
   * or if the report has been opted out or in automatically or manually. It will
   * start out as undefined until the iframe has started rendering the report becuase
   * the iframe is currently responsible for determining if its enabled. Hypothetically,
   * the main app could take over this responsibility if that's determined to be better.
   */
  enabled: boolean | undefined;
}

export const initialState: State = {
  inViewport: {},
  hasRendered: {},
  userHasScrolled: false,
  enabled: undefined,
};

const inViewportReducer = createReducer(
  initialState.inViewport,

  on(
    VirtualScrollActions.reportViewerSetInViewport,
    VirtualScrollActions.reportBuilderSetInViewport,
    (state, action) => ({
      ...state,
      ...action.intersections,
    })
  )
);

const hasRenderedReducer = createReducer(
  initialState.hasRendered,
  on(
    VirtualScrollActions.reportViewerSetHasRendered,
    VirtualScrollActions.reportBuilderSetHasRendered,
    (state, action) => ({
      ...state,
      [action.token]: action.rendered,
    })
  )
);

const userHasScrolledReducer = createReducer(
  initialState.userHasScrolled,

  on(
    VirtualScrollActions.reportViewerSetScrolled,
    VirtualScrollActions.reportBuilderSetScrolled,
    (state, action) => action.scrolled
  )
);

const enabledReducer = createReducer(
  initialState.enabled,
  on(
    VirtualScrollActions.reportViewerSetVirtualEnabled,
    VirtualScrollActions.reportBuilderSetVirtualEnabled,
    (state, action) => action.enabled
  )
);

export const reducer = {
  inViewport: inViewportReducer,
  hasRendered: hasRenderedReducer,
  userHasScrolled: userHasScrolledReducer,
  enabled: enabledReducer,
};
